import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import AnimateFromBottom from '../../LandingPage/component/AnimateFromBottom'
import useLocale from '../../../components/Hooks/useLocale'
import { urlWithLocalization } from '../../../components/LocalizationUrl/UrlWithLocalization'
import language from '../../../helpers/language'

const BuyerBenefits = () => {
  const [openIndex, setOpenIndex] = useState(0)
  const localeLocalization = useLocale()
  const lang = language.getLang()

  const benefits = lang?.buyerBenefits_items || []

  const toggle = (idx) => setOpenIndex(openIndex === idx ? null : idx)

  return (
    <section className="md:px-14 px-4 md:py-16 py-10" style={{ backgroundColor: "#f4fbfa" }}>
      <div className="max-w-5xl mx-auto">
        <AnimateFromBottom delay={0.1}>
          <div className="flex justify-center mb-6">
            <span className="border border-royal text-royal text-xs font-semibold px-5 py-1.5 rounded">
              {lang?.buyerBenefits_pill}
            </span>
          </div>
        </AnimateFromBottom>

        <AnimateFromBottom delay={0.2}>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 text-center" style={{ marginBottom: '50px' }}>
            {lang?.buyerBenefits_heading}
          </h2>
        </AnimateFromBottom>

        <AnimateFromBottom delay={0.3}>
          <div className="flex flex-col gap-4">
            {benefits.map((item, idx) => {
              const isOpen = openIndex === idx
              return (
                <div key={idx} className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                  <button
                    type="button"
                    onClick={() => toggle(idx)}
                    className="w-full flex items-center justify-between px-6 py-5 text-left"
                  >
                    <span className="font-semibold text-base text-gray-900">{item.title}</span>
                    <span className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${isOpen ? 'bg-royal' : 'bg-gray-100'}`}>
                      <i className={`fa text-xs ${isOpen ? 'fa-arrow-up text-white' : 'fa-arrow-down text-gray-500'}`} />
                    </span>
                  </button>

                  {isOpen && (
                    <div className="px-6 pb-6">
                      <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </AnimateFromBottom>

        {/* <AnimateFromBottom delay={0.4}>
          <div className="flex justify-center mt-10">
            <Link
              to={urlWithLocalization(localeLocalization, '/register/buyers')}
              className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white font-semibold text-sm px-8 py-3.5 rounded-md transition-colors shadow-sm"
            >
              <span>{lang?.buyerBenefits_cta}</span>
              <span className="w-7 h-7 rounded-full bg-white flex items-center justify-center">
                <i className="fa fa-arrow-right text-green-500 text-xs" />
              </span>
            </Link>
          </div>
        </AnimateFromBottom> */}
      </div>
    </section>
  )
}

export default BuyerBenefits
